import PropTypes from 'prop-types'
import React from 'react'

import {SORT_DIRECTIONS} from 'app/constants'

const Column = () => {}
Column.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  isSortable: PropTypes.bool,
  defaultSortDirection: PropTypes.string,
  sortBy: PropTypes.func,
  sortCompareFunction: PropTypes.func,
  baseWidth: PropTypes.number,
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  growRatio: PropTypes.number,
  shrinkRatio: PropTypes.number,
  cellContents: PropTypes.func,
  colSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
}
Column.defaultProps = {
  label: '',
  isSortable: false,
  defaultSortDirection: SORT_DIRECTIONS.ASC,
  sortBy: (item, column) => item[column.name],
  sortCompareFunction: (val1, val2) => {
    if (typeof val1 == 'string' && typeof val2 == 'string') {
      // If both values are strings, we need to keep locales in mind
      return val1.localeCompare(val2)
    }
    if (val1 < val2) return -1
    if (val1 > val2) return 1
    return 0
  },
  growRatio: 1,
  shrinkRatio: 1,
  cellContents: (item, column) => item[column.name],
  colSpan: 1,
}

export default Column
